import api from '../api';

export class PostDetailService {
  static async getPostDetail(payload: any) {
    return api.getApiCall(`api/v1/admins/posts/post?postId=${payload}`);
  }
}
